// src/components/chat/ChatInput.tsx
import React, { useState, FormEvent, ChangeEvent, useRef, useEffect } from 'react';
import { InputContainer, Input, SendButton } from './styles/ChatStyles';

interface ChatInputProps {
  onSendMessage: (message: string) => void;
  disabled?: boolean;
  onUserActivity?: () => void;
}

export const ChatInput: React.FC<ChatInputProps> = ({ onSendMessage, disabled, onUserActivity }) => {
  const [message, setMessage] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!disabled && inputRef.current) {
      inputRef.current.focus();
    }
  }, [disabled]);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (message.trim()) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setMessage(e.target.value);
    onUserActivity?.();
  };

  return (
    <InputContainer as="form" onSubmit={handleSubmit}>
      <Input
        ref={inputRef}
        type="text"
        value={message}
        onChange={handleChange}
        onFocus={onUserActivity}
        onKeyDown={onUserActivity}
        placeholder="Type your message..."
        disabled={disabled}
        aria-label="Message input"
      />
      <SendButton 
        type="submit" 
        disabled={disabled || !message.trim()}
        aria-label="Send message"
      >
        Send
      </SendButton>
    </InputContainer>
  );
};
